import React, {Component} from 'react';
import {getGameTitle} from '../../../../../helpers/eventHelpers';
import {getText} from '../../../../../helpers/localization';
import OpenBet from '../../../components/openBet';

class OpenBetFirstDown extends Component {

    render() {

        let name = isNaN(this.props.betSelection.bets[0].market.selection)
            ? getText(this.props.betSelection.bets[0].market.selection, this.props.store)
            : this.props.betSelection.bets[0].market.selection;
        let names = [name];

        let eventName = getGameTitle(this.props.betSelection.bets[0].event.title, this.props.betSelection.bets[0].event.eventTimeDate, this.props.store.getState().vpp.systemLanguage);
        let betType = getText(this.props.betSelection.bets[0].betType.name, this.props.store);
        let odd = this.props.betSelection.bets[0].market.odds;

        return (
            <OpenBet
                store={this.props.store}
                index={this.props.index}
                betSelection={this.props.betSelection}
                names={names}
                betType={betType}
                odd={odd}
                eventName={eventName}
                isEnabled={this.props.isEnabled}
                openBetFocusCallback={this.props.openBetFocusCallback}/>
        );
    }
}

export default OpenBetFirstDown;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/components/openBetFirstDown.js